import axios from 'axios'
import {
  Message
} from 'element-ui';
import store from '../store'
import {
  delCookie
} from "@/utils/auth";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 5000 // 请求超时时间
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    // res.code = 20000
    // console.log(response.status, res) // for debug
    if (res.code !== 200) {
    //   console.log(res);
      if (res.code == 401) {
        Message({
          message: '登录过期',
          type: 'error',
          duration: 3 * 1000
        })
        delCookie("token");
        localStorage.removeItem("user", null);
        store.commit("setUser", {});
        store.commit("setActive", 0);
        store.commit("setList", []);
      }else if(res.code === 500){
        Message({
            message: res.message,
            type: 'error',
            duration: 3 * 1000
          })
      } else {
        return response.data
      }
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    delCookie("token");
    localStorage.removeItem("user", null);
    store.commit("setUser", {});
    store.commit("setActive", 0);
    store.commit("setList", []);
    
    // Message({
    //   message: '网络错误',
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js